import React, { useCallback, useState, createContext, useContext } from 'react';
import { OptInModal } from './OptInModal';
interface OptInContextValue {
  /** Open the opt-in form; on submit/skip the user is sent to `destination`. */
  openOptIn: (destination: string) => void;
}
const OptInContext = createContext<OptInContextValue | null>(null);
export function OptInProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const [destination, setDestination] = useState<string | null>(null);
  const openOptIn = useCallback((dest: string) => {
    setDestination(dest);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);
  return <OptInContext.Provider value={{
    openOptIn
  }} data-id="element-100">
      {children}
      <OptInModal open={open} destination={destination} onClose={close} data-id="element-101" />
    </OptInContext.Provider>;
}
export function useOptIn(): OptInContextValue {
  const ctx = useContext(OptInContext);
  if (!ctx) {
    throw new Error('useOptIn must be used within an OptInProvider');
  }
  return ctx;
}